import DashboardDefault from 'views/dashboard/Default';
import SettingsDashboard from 'views/dashboard/SettingsDashboard';
import SettingsSales from 'views/dashboard/SettingsSales';
import MainLayout from 'layout/MainLayout';
import Profilesetting from 'views/profilesettings';
import Settings from 'views/settings/Main';
import UserView from 'views/users';
import ReportView from 'views/reports';
import ViewUserView from 'views/users/Viewuser';
import ProductsList from 'views/products';
import ProductView from 'views/products/ProductView';
import ProductForm from 'views/products/ProductForm';
import ExportProduct from 'views/products/ExportProduct';
import ImportProduct from 'views/products/ImportProduct';
import SerialsList from 'views/serials';
import SerialsDetails from 'views/serials/SerialsDetails';
import Shipments from 'views/shipments';
import CreateRoles from 'views/settings/CreateRoles';
import EditRoles from 'views/settings/EditRoles';
import ViewRoleDetails from 'views/settings/ViewRoleDetail';
import Auth from 'ui-component/Auth';
import Estimation from 'views/estimation';
import Backorders from 'views/backorders';
import ProductCategories from 'views/productCategories';
import CategoryForm from 'views/productCategories/CategoryForm';
import ShipmentDetails from 'views/shipments/ShipmentDetails';
import Notifications from 'views/Notifications';
import EstimationDetails from 'views/estimation/EstimationDetails';
import RolesList from 'views/settings/RolesList';
import UserForm from 'views/users/UserForm';
import Contacts from 'views/contacts';
import ContactForm from 'views/contacts/ContactForm';
import ContactsApprove from 'views/contacts/contactsApprove';
import ContactDetails from 'views/contacts/ContactDetails';
import CreditNoteForm from 'views/credit-notes/CreditNoteForm';
import CreditNotes from 'views/credit-notes';
import CreditNoteDetails from 'views/credit-notes/CreditNoteDetails';
import Warehouses from 'views/warehouses';
import WarehouseDetails from 'views/warehouses/WarehouseDetails';
import WarehouseForm from 'views/warehouses/WarehouseForm';
import ComingSoon from 'views/coming-soon';
import OrderForm from 'views/estimation/OrderForm/OrderForm';

// Invoices
import InvoiceList from 'views/invoices';

// Returns
import Returns from 'views/returns';
import ReturnsDetails from 'views/returns/ReturnsDetails';


// Purchasing 
import Purchasing from 'views/purchasing';
import PurchasingForm from 'views/purchasing/PurchasingForm';
import PurchasingDetails from 'views/purchasing/PurchasingDetails';
import PurchasingReceiptForm from 'views/purchasing/PurchasingReceiptForm';

// Vendor Credits
import VendorCredit from 'views/vendorCredits';
import VendorCreditForm from 'views/vendorCredits/VendorCreditForm';
import VendorCreditDetails from 'views/vendorCredits/VendorCreditDetails';


// Operations
import Operation from 'views/Operations';
import OperationDetails from 'views/Operations/OperationDetails';
import OperationInboundView from 'views/Operations/OperationInboundView';
import OperationQualityControlView from 'views/Operations/OperationQualityControlView';
import OperationRepairsView from 'views/Operations/OperationRepairsView';


// Transactions
import Transactions from 'views/transaction';


// Sales Orders
import SalesOrders from 'views/SalesOrders';
import SalesOrderForm from 'views/SalesOrders/SalesOrderForm';
import SalesOrderDetails from 'views/SalesOrders/SalesOrderDetails';

// Picklists
import Picklist from 'views/picklists';
import PicklistDetails from 'views/picklists/PicklistDetails';

// Reports
import ProfitLossStatement from 'views/reports/ProfitLossStatement'
import ProfitLossSalesStatement from 'views/reports/ProfitLossStatement/ProfitLossSalesStatement'
import ProfitLossPurchaseOrdersStatement from 'views/reports/ProfitLossStatement/ProfitLossPurchaseOrdersStatement'
import ProfitLossShippingCostsStatement from 'views/reports/ProfitLossStatement/ProfitLossShippingCostsStatement'

// Reports
import ContactRevenue from 'views/reports/ContactRevenue'
import ContactRevenueDetails from 'views/reports/ContactRevenue/ContactRevenueDetails'

// Reports
import ContactExpense from 'views/reports/ContactExpense'
import ContactExpenseDetails from 'views/reports/ContactExpense/ContactExpenseDetails'

// Settings
import SettingsCompanyDetails from 'views/settings/SettingsCompanyDetails';
import SettingsGeneralSettings from 'views/settings/SettingsGeneralSettings';
import SettingsModels from 'views/settings/SettingsModels';
import SettingsGrades from 'views/settings/SettingsGrades';
import SettingsColors from 'views/settings/SettingsColors';
import SettingsBanks from 'views/settings/SettingsBanks';
import SettingsShippingCompany from 'views/settings/SettingsShippingCompany';
import SettingsRepairs from 'views/settings/SettingsRepairs';
import SettingsSpecifications from 'views/settings/SettingsSpecifications';
import SettingsInterests from 'views/settings/SettingsInterests';
import CoolmixSettings from 'views/settings/integrations/CoolmixSettings';


// Testings
import TestPage from 'views/testpage';
import { element } from 'prop-types';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const MainRoutes = {
	path: '/',
	element: <MainLayout />,
	children: [
		{
			path: 'dashboard',
			children: [
				{
					path: '',
					element: (
						<Auth>
							<DashboardDefault />
						</Auth>
					)
				}
			]
		},
		{
			path: 'dashboard-settings',
			children: [
				{
					path: '',
					element: (
						<Auth>
							<SettingsDashboard />
						</Auth>
					)
				}
			]
		},
		{
			path: 'sales-settings',
			children: [
				{
					path: '',
					element: (
						<Auth>
							<SettingsSales />
						</Auth>
					)
				}
			]
		},
		{
			path: 'coming-soon',
			children: [
				{
					path: '',
					element: (
						<Auth>
							<ComingSoon />
						</Auth>
					)
				}
			]
		},
		{
			path: 'contacts',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Contact (Page)']}>
							<Contacts />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Contact (Page)']}>
							<ContactForm />
						</Auth>
					)
				},
				{
					path: 'portal',
					element: <ContactsApprove />
				},

				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Contact Details (Page)']}>
							<ContactDetails />
						</Auth>
					)
				},
				{
					path: 'edit/:id',
					element: (
						<Auth requiredPermissions={['Edit Contact (Page)']}>
							<ContactForm edit />
						</Auth>
					)
				}
			]
		},

		// Model
		{
			path: 'settings',
			children: [
				{
					path: 'company-details',
					element: (
						<Auth>
							<SettingsCompanyDetails />
						</Auth>
					)
				},
				{
					path: 'general-settings',
					element: (
						<Auth>
							<SettingsGeneralSettings />
						</Auth>
					)
				},
				{
					path: 'grades',
						element: (
						<Auth>
							<SettingsGrades />
						</Auth>
					)
				},
				{
					path: 'colors',
					element: (
						<Auth>
							<SettingsColors />
						</Auth>
					)
				},
				{
					path: 'models',
					element: (
						<Auth>
							<SettingsModels />
						</Auth>
					)
				},
				{
					path: 'banks',
					element: (
						<Auth>
							<SettingsBanks />
						</Auth>
					)
				},
				{
					path: 'repairs',
					element: (
						<Auth>
							<SettingsRepairs />
						</Auth>
					)
				},
				{
					path: 'specifications',
					element: (
						<Auth>
							<SettingsSpecifications />
						</Auth>
					)
				},
				{
					path: 'interests',
					element: (
						<Auth>
							<SettingsInterests />
						</Auth>
					)
				},
				{
					path: 'shipping-companies',
					element: (
						<Auth>
							<SettingsShippingCompany />
						</Auth>
					)
				},
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List User (Page)']}>
							<Settings />
						</Auth>
					)
				},
				{
					path: 'user',
					element: (
						<Auth requiredPermissions={['List User (Page)']}>
							<UserView />
						</Auth>
					)
				},
				{
					path: 'user/:id',
					element: (
						<Auth requiredPermissions={['View User Details (Page)']}>
							<ViewUserView />
						</Auth>
					)
				},
				{
					path: 'user/edit/:id',
					element: (
						<Auth requiredPermissions={['Update User (Page)']}>
							<UserForm edit />
						</Auth>
					)
				},
				{
					path: 'user/create',
					element: (
						<Auth requiredPermissions={['Create New User (Page)']}>
							<UserForm />
						</Auth>
					)
				},
				//Product Categories
				{
					path: 'productcategories',
					children: [
						{
							path: '',
							element: (
								<Auth>
									<ProductCategories />
								</Auth>
							)
						},
						{
							path: 'create',
							element: (
								<Auth>
									<CategoryForm />
								</Auth>
							)
						},
						{
							path: ':id',
							element: (
								<Auth>
									<CategoryForm edit />
								</Auth>
							)
						}
					]
				},
				{
					path: 'integrations',
					children: [
						{
							path: 'coolmix',
							element: (
								<Auth>
									<CoolmixSettings />
								</Auth>
							)
						}
					]
				},
			]
		},
		{
			path: 'reports',
			children: [
				{
					path: '',
					element: <ReportView />
				},
				{
					path: 'profit-loss-statement',
					children: [
						{
							path: '',
							element: (
								<ProfitLossStatement />
							),
						},
						{
							path: 'sales',
							element: (
								<ProfitLossSalesStatement />
							),
						},
						{
							path: 'purchase-orders',
							element: (
								<ProfitLossPurchaseOrdersStatement />
							),
						},
						{
							path: 'shipping-costs',
							element: (
								<ProfitLossShippingCostsStatement />
							),
						}
					]
				},
				{
					path: 'contact-revenue',
					children: [
						{
							path: '',
							element: (
								<ContactRevenue />
							),
						},
						{
							path: 'contact',
							element: (
								<ContactRevenueDetails />
							),
						},
					]
				},
				{
					path: 'contact-expense',
					children: [
						{
							path: '',
							element: (
								<ContactExpense />
							),
						},
						{
							path: 'contact',
							element: (
								<ContactExpenseDetails />
							),
						},
					]
				},
				// {
				// 	path: ':id',
				// 	element: <ReportType />
				// },
			]
		},

		{
			path: 'credit-note',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Credit Note (Page)']}>
							<CreditNotes />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Credit Note (Page)']}>
							<CreditNoteForm />
						</Auth>
					)
				},
				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['Credit Note Details (Page)']}>
							<CreditNoteDetails />
						</Auth>
					)
				},
				{
					path: 'edit/:id',
					element: (
						<Auth requiredPermissions={['Update Credit Note (Page)']}>
							<CreditNoteForm edit />
						</Auth>
					)
				}
			]
		},

		{
			path: 'order',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Estimation (Page)']}>
							{/* <Estimation globalPrivacyMode={globalPrivacyMode} /> */}
							<Estimation />
						</Auth>
					)
				},
				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Estimation Details (Page)']}>
							<EstimationDetails />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Estimation (Page)']}>
							<OrderForm type="estimate" />
						</Auth>
					)
				},
				{
					path: 'create/invoice',
					element: (
						<Auth requiredPermissions={['Create Estimation (Page)']}>
							<OrderForm type="invoice" />
						</Auth>
					)
				},
				{
					path: 'create/credit-note',
					element: (
						<Auth requiredPermissions={['Create Estimation (Page)']}>
							<OrderForm type="credit-note" />
						</Auth>
					)
				},
				{
					path: 'create2',
					element: (
						<Auth requiredPermissions={['Create Estimation (Page)']}>
							<OrderForm />
						</Auth>
					)
				},
				{
					path: 'edit/:id',
					element: (
						<Auth requiredPermissions={['Edit Estimation (Page)']}>
							<OrderForm edit />
						</Auth>
					)
				},
				{
					path: 'draft/:id',
					element: (
						<Auth requiredPermissions={['Edit Estimation (Page)']}>
							<OrderForm draft />
						</Auth>
					)
				}
			]
		},

		{
			path: 'sales',
			children: [
				{
					path: 'quotations',
					children: [
						{
							path: '',
							element: (
								<Auth requiredPermissions={['List Estimation (Page)']}>
									<Estimation />
								</Auth>
							)
						},
						{
							path: ':id',
							element: (
								<Auth requiredPermissions={['View Estimation Details (Page)']}>
									<EstimationDetails />
								</Auth>
							)
						},
						{
							path: 'edit/:id',
							element: (
								<Auth requiredPermissions={['Edit Estimation (Page)']}>
									<OrderForm edit />
								</Auth>
							)
						},
						{
							path: 'create',
							element: (
								<Auth requiredPermissions={['Create Estimation (Page)']}>
									<OrderForm type="estimate" />
								</Auth>
							)
						},
						{
							path: 'draft/:id',
							element: (
								<Auth requiredPermissions={['Edit Estimation (Page)']}>
									<OrderForm edit type="draft-estimate" />
								</Auth>
							)
						}
					]
				},
				{
					path: 'estimates',
					children: [
						{
							path: '',
							element: (
								<Auth requiredPermissions={['List Estimation (Page)']}>
									<Estimation />
								</Auth>
							)
						},
						{
							path: ':id',
							element: (
								<Auth requiredPermissions={['View Estimation Details (Page)']}>
									<EstimationDetails />
								</Auth>
							)
						},
						{
							path: 'edit/:id',
							element: (
								<Auth requiredPermissions={['Edit Estimation (Page)']}>
									<OrderForm edit />
								</Auth>
							)
						},
						{
							path: 'create',
							element: (
								<Auth requiredPermissions={['Create Estimation (Page)']}>
									<OrderForm type="estimate" />
								</Auth>
							)
						},
						{
							path: 'draft/:id',
							element: (
								<Auth requiredPermissions={['Edit Estimation (Page)']}>
									<OrderForm edit type="draft-estimate" />
								</Auth>
							)
						}
					]
				},
				{
					path: 'invoices',
					children: [
						{
							path: '',
							element: (
								<Auth requiredPermissions={['List Estimation (Page)']}>
									{/* <Estimation /> */}
									<InvoiceList />
								</Auth>
							)
						},
						{
							path: ':id',
							element: (
								<Auth requiredPermissions={['View Estimation Details (Page)']}>
									<EstimationDetails />
								</Auth>
							)
						},
						{
							path: 'edit/:id',
							element: (
								<Auth requiredPermissions={['Edit Estimation (Page)']}>
									<OrderForm edit />
								</Auth>
							)
						},
						{
							path: 'create',
							element: (
								<Auth requiredPermissions={['Create Estimation (Page)']}>
									<OrderForm type="invoice" />
								</Auth>
							)
						},
						{
							path: 'draft/:id',
							element: (
								<Auth requiredPermissions={['Edit Estimation (Page)']}>
									<OrderForm edit type="draft-invoice" />
								</Auth>
							)
						}
					]
				},
				{
					path: 'credit-note/create',
					element: (
						<Auth requiredPermissions={['Create Estimation (Page)']}>
							<OrderForm type="credit-note" />
						</Auth>
					)
				},
				// transactions
				{
					path: 'transactions',
					element: (
						<Auth requiredPermissions={['Edit Estimation (Page)']}>
							<Transactions />
						</Auth>
					)
				},
				// Sales Orders
				{
					path: 'sales-orders',
					children: [
						{
							path: '',
							element: (
								<Auth requiredPermissions={['List Sales Orders']}>
									<SalesOrders />
								</Auth>
							)
						},
						{
							path: ':id',
							element: (
								<Auth requiredPermissions={['View Sales Orders Details']}>
									<SalesOrderDetails />
								</Auth>
							)
						},
						{
							path: 'edit/:id',
							element: (
								<Auth requiredPermissions={['Edit Sales Order']}>
									<SalesOrderForm edit />
								</Auth>
							)
						},
						{
							path: 'create',
							element: (
								<Auth requiredPermissions={['Create Sales Order']}>
									<SalesOrderForm />
								</Auth>
							)
						},
						{
							path: 'draft/:id',
							element: (
								<Auth requiredPermissions={['Edit Sales Order']}>
									<OrderForm edit type="draft-sales-order" />
								</Auth>
							)
						}
					]
				},
			]
		},

		{
			path: 'backorders',
			children: [
				{
					path: '',
					element: (
						// <Auth requiredPermissions={['List Backorder (Page)']}>
						<Backorders />
						// </Auth>
					)
				},
			]
		},

		// Picklists
		{
			path: 'picklists',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Picklists (Page)']}>
							<Picklist />
						</Auth>
					)
				},
				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Picklists (Button)']}>
							<PicklistDetails />
						</Auth>
					)
				},
			]
		},
		{
			path: 'user',
			children: [
				{
					path: 'profile',
					element: (
						<Auth>
							<Profilesetting />
						</Auth>
					)
				}
			]
		},
		,
		{
			path: 'settings',
			children: [
				{
					path: 'rolecreate',
					element: (
						<Auth>
							<CreateRoles />
						</Auth>
					)
				}
			]
		},
		{
			path: 'settings',
			children: [
				{
					path: 'roleedit/:id',
					element: (
						<Auth>
							<EditRoles />
						</Auth>
					)
				}
			]
		},
		{
			path: 'settings',
			children: [
				{
					path: 'roleview/:id',
					element: (
						<Auth>
							<ViewRoleDetails />
						</Auth>
					)
				}
			]
		},
		{
			path: 'settings',
			children: [
				{
					path: 'role',
					element: (
						<Auth requiredPermissions={['List Role (Page)']}>
							<RolesList />
						</Auth>
					)
				}
			]
		},
		// Purchase List
		{
			path: 'purchasing',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Purchase Order']}>
							<Purchasing />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Purchase Order']}>
							<PurchasingForm />
						</Auth>
					)
				},
				{
					path: 'view/:id',
					element: (
						<Auth requiredPermissions={['View Purchase Order']}>
							<PurchasingDetails />
						</Auth>
					)
				},
				{
					path: 'edit/:id',
					element: (
						<Auth requiredPermissions={['Edit Purchase Order']}>
							<PurchasingForm edit />
							{/* <PurchasingInvoiceForm /> */}
						</Auth>
					)
				},
				{
					path: 'create/:id/receipt',
					element: (
						<Auth requiredPermissions={['Edit Purchase Order']}>
							<PurchasingReceiptForm />
						</Auth>
					)
				},
				{
					path: 'view/:id/receipt',
					element: (
						<Auth requiredPermissions={['Edit Purchase Order']}>
							<PurchasingReceiptForm edit />
						</Auth>
					)
				},
			]
		},
		{
			path: 'vendor-credits',
			children: [
				{
					path: '',
					element: (
						// <Auth requiredPermissions={['List Purchase Order']}>
							<VendorCredit />
						// </Auth>
					)
				},
				{
					path: 'create',
					element: (
						// <Auth requiredPermissions={['List Purchase Order']}>
							<VendorCreditForm />
						// </Auth>
					)
				},
				{
					path: ':id',
					element: (
						// <Auth requiredPermissions={['Purchase Invoice Details (Page)']}>
							<VendorCreditDetails />
						// </Auth>
					)
				},
				{
					path: 'edit/:id',
					element: (
						// <Auth requiredPermissions={['Edit Sales Order']}>
							<VendorCreditForm edit />
						// </Auth>
					)
				},
			]
		},
		// Operations

		{
			path: 'operations',
			children: [
			
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Operations']}>
							<Operation />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Operations']}>
							<OperationDetails />
						</Auth>
					)
				},
				{
					path: 'edit/:id/inbound',
					element: (
						<Auth requiredPermissions={['View Operations Details']}>
							<OperationDetails edit />
						</Auth>
					)
				},
				{
					path: 'view',
					children: [
						{
							path: ':id/',
							children: [
								{
									path: 'inbound',
									element: (
										<Auth requiredPermissions={['View Operations Details']}>
											<OperationInboundView edit />
										</Auth>
									)
								},
								{
									path: 'qualitycontrol',
									element: (
										<Auth requiredPermissions={['List Quality Control']}>
											<OperationQualityControlView edit />
										</Auth>
									)
								},
								{
									path: 'repairs',
									element: (
										<Auth requiredPermissions={['List Operation Repairs']}>
											<OperationRepairsView edit />
										</Auth>
									)
								},
							]
						},
					]
				},
				
			]
		},

		{
			path: 'notifications',
			element: (
				<Auth>
					<Notifications />
				</Auth>
			)
		},

		{
			path: 'shipments',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Shipment (Page)']}>
							<Shipments />
						</Auth>
					)
				},
				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Shipment Details (Page)']}>
							<ShipmentDetails />
						</Auth>
					)
				}
			]
		},
		{
			path: '*',
			element: (
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						zIndex: 99999,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100dvh',
						width: '100vw',
						background: '#f9f9f9',
						flexDirection: 'column',
						gap: '0px'
					}}
				>
					<h1>404</h1>
					<h6>Page Not Found</h6>
				</div>
			)
		},
		//Task board Inbounding
		{
			path: 'serials',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Product (Page)']}>
							<SerialsList />
						</Auth>
					)
				},
				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Product (Button)']}>
							<SerialsDetails />
						</Auth>
					)
				}
			]
		},
		{
			path: 'warehouses',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Warehouse (Page)']}>
							<Warehouses />
						</Auth>
					)
				},
				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Warehouse Details (Page)']}>
							<WarehouseDetails />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Warehouse (Page)']}>
							<WarehouseForm />
						</Auth>
					)
				},
				{
					path: 'edit/:id',
					element: (
						<Auth requiredPermissions={['Update Warehouse (Page)']}>
							<WarehouseForm edit />
						</Auth>
					)
				}
			]
		},
		{
			path: 'returns',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Returns (Page)']}>
							<Returns />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Returns (Page)']}>
							<ReturnsDetails />
						</Auth>
					)
				},
				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Returns Details (Page)']}>
							<ReturnsDetails edit />
						</Auth>
					)
				}
			]
		},

		{
			path: 'products',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Model (Page)']}>
							<ProductsList />
						</Auth>
					)
				},
				{
					path: 'inactive',
					element: (
						<Auth requiredPermissions={['List Model (Page)']}>
							<ProductsList />
						</Auth>
					)
				},
				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Model Details (Page)']}>
							<ProductView />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Model (Page)']}>
							<ProductForm />
						</Auth>
					)
				},
				{
					path: 'edit/:id',
					element: (
						<Auth requiredPermissions={['Update Warehouse (Page)']}>
							<ProductForm edit />
						</Auth>
					)
				},
				{
					path: 'export',
					element: (
						<Auth requiredPermissions={['List Model (Page)']}>
							<ExportProduct />
						</Auth>
					)
				},
				{
					path: 'import',
					element: (
						<Auth requiredPermissions={['List Model (Page)']}>
							<ImportProduct />
						</Auth>
					)
				}
			]
		},
		{
			path: 'test',
			children: [
				{
					path: '',
					element: (
						<Auth>
							<TestPage />
						</Auth>
					)
				}
			]
		},
	]
};

export default MainRoutes;

